<template>
  <div class="clearfix">
    <div class="clear hei40"></div>
    <div class="con-width-1200 content">
      <div class="public-title clearfix pos-rel">
        <h2 class="pos-rel course">ExpertTeam</h2>
        <h1 class="pos-abs">专家团队</h1>
        <div class="catage clearfix pos-abs">您所在位置：首页 > 专家团队 > 列表</div>
      </div>
    </div>

    <div class="list-block clearfix">
      <div class="list clearfix">
        <div class="item" v-for="(item, index) in imgList" :key="index">
          <img title :src="item.toux" @click="jump(item.id)" />
          <div class="info">
            <div class="inline">
              <div class="h2">{{ item.xingm }}</div>
              <div class="p">{{ item.jianj | ellipsis }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="r-top rad5" @click="$router.go(-1)">
      <i class="iconfont icon-fanhuidingbu"></i>
      <a>返回上级</a>
    </div>

  </div>
</template>

<script>
import _http from "../httpService";

export default {
  name: "HospitalSummedup",
  props: {
    msg: String,
  },
  components: {},
  data() {
    return {
      dataList: [],
      imgList: [],
      isDisable: false,
      name: "",
      mobile: "",
      content: "",
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 25) {
        return value.slice(0, 25) + "...";
      }
      return value;
    },
  },
  methods: {
    jump: function (id) {
      this.$router.push({ path: "/Article01/" + id });
    },
  },
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    $route() {
      _http
        .get(
          "/zhuanjjslb/zhuanjjs/queryZhuanjjsZjByMainId?id=" +
          this.$route.params.id +
          "&pageNo=" +
          this.pageNo +
          "&pageSize=" +
          this.pageSize
        )
        .then((resp) => {
          if (resp.data.success) {
            this.imgList = resp.data.result;
          }
        })
        .catch((error) => console.log(error))
        .finally(() => (this.loading = false));
    },
    immediate: true,
  },
  created() {
    // 初始化加载栏目等数据
    _http
      .get(
        "/zhuanjjslb/zhuanjjs/queryZhuanjjsZjByMainId?id=" +
        this.$route.params.id
      )
      .then((resp) => {
        if (resp.data.success) this.imgList = resp.data.result;
      })
      .catch((error) => console.log(error))
      .finally(() => (this.loading = false));
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/css/public.css";
@import "../assets/css/public.scss";

.list-block {
  width: 1240px;
  margin: 0 auto;
}

.list-block .list .item {
  width: 237px;
  height: 347px;
  overflow: hidden;
  position: relative;
  margin: 0px 5px;
  margin-bottom: 11px;
  float: left;
}

.list-block .list .item img {
  width: 100%;
}

.list-block .item .info {
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: auto;
  text-align: center;
  min-height: 97px;
}

.list-block .item .inline {
  display: inline-block;
  vertical-align: middle;
  padding: 15px 15px;
}

.list-block .item .h2 {
  font-size: 18px;
  color: #fff;
}

.list-block .item .p {
  font-size: 14px;
  color: #fff;
  line-height: 22px;
  margin-top: 8px;
}</style>
